/**
 * Null-sicheres JSON-Parsen: gibt bei fehlendem (null/undefined), leerem oder
 * korruptem Inhalt null zurück, statt zu crashen — z.B. beim Direktaufruf einer
 * Seite mit kaputtem oder geräumtem Storage.
 */
export function safeJsonParse<T>(raw: string | null): T | null {
    if (raw == null) return null
    try {
        return JSON.parse(raw) as T
    } catch {
        return null
    }
}
